const state = {
  drawnPlots: [

  ],
  plotExecuterIndex: 0,
  plotName: [
    { id: 1, name: "強力なリーダー", effect: "使用者はリーダーになれる．(リーダーが変わるタイミングで使用可能．)" },
    { id: 2, name: "監視者", effect: "他のプレイヤーのミッション行動を覗くことができる．(ミッション行動後に使用可能．)" },
    { id: 3, name: "総意の形成者", effect: "総意の形成者となり，他のプレイヤーよりも先に投票を行う．" },
    { id: 4, name: "不信", effect: "投票で確定されたミッションメンバーを無効にできる．(ミッションメンバーが確定されたタイミングで使用可能．)" },
    { id: 5, name: "責任者", effect: "他のプレイヤーの陰謀カードを１枚引きとる．(このカードを渡されたタイミングで使用．)" },
    { id: 6, name: "立ち聞きされた会話", effect: "前後どちらかのプレイヤーの役割を覗く．(このカードを渡されたタイミングで使用．)" },
    { id: 7, name: "情報開示", effect: "自分の役割を他のプレイヤー１人に開示する．(このカードを渡されたタイミングで使用．)" },
    { id: 8, name: "信用の確立", effect: "他のプレイヤー１人に自分の役割を明かす．(このカードを引いたリーダーが使用．)" },
    { id: 9, name: "注目の的", effect: "他のプレイヤー1人を選択する．選択されたプレイヤーのミッション行動は全員に開示される．(ミッションメンバーが決定した後に使用可能．)" },
  ],
  watchedUserIds: []
}

const getters = {
  getPlotName: function(state) {
    return (plotId) => state.plotName.find(plot => plot.id == plotId).name
  },
  getPlotEffect: function(state) {
    return (plotId) => state.plotName.find(plot => plot.id == plotId)
  },
  getPlotById: () => (id) => {
    return state.plotName.find(plot => plot.id == id)
  },
  getDrawnPlots: (state) => (round) => {
    return state.drawnPlots[round]
  }
}

const actions = {
  // getPlotName({ commit }) {
  //   commit('getPlotName')
  // }
  addDrawnPlots({ commit }) {
    commit('addDrawnPlots')
  },
  deleteDrawnPlot({ commit }) {
    commit('deleteDrawnPlot')
  },
  initExecuterIndex({ commit }) {
    commit('initExecuterIndex')
  },
  proceedExecuterIndex({ commit }) {
    commit('proceedExecuterIndex')
  },
  clearWatchedUserIds({ commit }) {
    commit('clearWatchedUserIds')
  },
  pushWatchedUserId({ commit }) {
    commit('pushWatchedUserId')
  }
}

const mutations = {
  addDrawnPlots(state, payload) {
    console.log(payload)
    console.log(payload.plots)
    console.log(state.plotName)
    var plots = []
    for (var i in payload.plots){
      var plot = Object.assign({}, state.plotName.find(plot => plot.id == payload.plots[i]));
      plot.index = i
      plots.push(plot);
    }
    state.drawnPlots.push(plots)
    console.log(state.drawnPlots)
  },
  deleteDrawnPlot(state, payload) {
    for (var i in state.drawnPlots[payload.round]){
      if (state.drawnPlots[payload.round][i].id == payload.plotId){
        state.drawnPlots[payload.round].splice(i,1)
      }
    }
    for (var j in state.drawnPlots[payload.round]){
      state.drawnPlots[payload.round][j].index = j
    }
    console.log(state.drawnPlots[payload.round])
  },
  initExecuterIndex(state) {
    state.plotExecuterIndex = 0
  },
  proceedExecuterIndex(state) {
    state.plotExecuterIndex += 1
  },
  clearWatchedUserIds(state) {
    state.watchedUserIds.splice(0)
  },
  pushWatchedUserId(state, payload) {
    console.log("push watched user:" + payload)
    state.watchedUserIds.push(payload.userId)
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
